module.exports = __webpack_public_path__ + "static/img/IMG_20170720_225055.59a062d1.jpg";